import React, { useEffect, useState } from "react";

export function CatalogPage() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch("/data/episodes.json")
      .then((r) => r.json())
      .then(setData)
      .catch((err) => setError(err.message));
  }, []);

  if (error) return <p style={{ color: "#ff7a8c" }}>Error: {error}</p>;
  if (!data) return <p style={{ color: "#86a3d9" }}>Cargando episodios…</p>;

  const groups = ["flash", "explica", "course"];
  return (
    <div style={{ maxWidth: 980, margin: "0 auto", padding: "24px 12px" }}>
      <h1 style={{ fontSize: 28, fontWeight: 600, letterSpacing: "-0.02em" }}>
        Catálogo editorial · {data.counts.total} episodios
      </h1>
      <p style={{ color: "#a8b9d9", fontSize: 14 }}>
        Generado desde los YAML del paquete EducaFCEF v1.0.{" "}
        <span className="mono" style={{ color: "#6e85b3", fontSize: 11 }}>
          {data.generated_at}
        </span>
      </p>

      {groups.map((fmt) => {
        const list = data.episodes.filter((e) => e.format === fmt);
        if (!list.length) return null;
        return (
          <section key={fmt} style={{ marginTop: 26 }}>
            <h2 style={{ fontSize: 17, fontWeight: 600, margin: "0 0 8px" }}>
              {fmt.toUpperCase()} · {list.length}
            </h2>
            <div style={{ display: "grid", gap: 10 }}>
              {list.map((ep) => (
                <EpisodeCard key={ep.id} ep={ep} />
              ))}
            </div>
          </section>
        );
      })}
    </div>
  );
}

function EpisodeCard({ ep }) {
  return (
    <article
      style={{
        background: "rgba(127,182,255,0.04)",
        border: "1px solid rgba(168,185,217,0.10)",
        padding: 16,
        borderRadius: 12,
      }}
    >
      <div className="mono" style={{ fontSize: 10.5, letterSpacing: "0.10em", textTransform: "uppercase", color: "#7d97c8" }}>
        {ep.id} · {ep.level} · {ep.topic_family}
      </div>
      <div style={{ fontSize: 18, fontWeight: 600, marginTop: 6, letterSpacing: "-0.01em" }}>
        {ep.readable_name}
      </div>
      <div style={{ color: "#a8b9d9", fontSize: 13, marginTop: 6 }}>
        {ep.objectives?.[0] || "—"}
      </div>
      {ep.misconceptions?.length > 0 && (
        <div
          style={{
            marginTop: 10,
            padding: "8px 10px",
            background: "rgba(255,122,140,0.10)",
            borderRadius: 8,
            fontSize: 12.5,
            color: "#f5d6dc",
          }}
        >
          <strong>Ojo:</strong> {ep.misconceptions[0]}
        </div>
      )}
      <div style={{ marginTop: 10, display: "flex", gap: 12, fontSize: 11, color: "#6e85b3" }} className="mono">
        <span>{ep.duration?.target_s ? `${ep.duration.target_s}s objetivo` : ""}</span>
        <span>{ep.narrative?.length ? `${ep.narrative.length} actos` : ""}</span>
        <span>{ep.exercise_pack?.items?.length ? `${ep.exercise_pack.items.length} ejercicios` : ""}</span>
      </div>
    </article>
  );
}
